import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { FetchHandler } from "../../Handlers/FetchHandler";
import { useUsers } from "../../hooks/useUsers";
import { RestListContainer, StringObjectDictionary } from "../../Types";
import { CHANGE_ORG_ORGANIZATION, CHANGE_ORG_ORGANIZATION_USERS, OrganizationModelType, OrganizationUsersModelType } from "../../rdx/organizationReducer";
import { RdxStore } from "../../rdx/ReduxTypes";
export type OrganizationAccounType = "premium" | "trial" | "basic";
export const useOrganizations = () => {

    const dispatch = useDispatch();

    const organizations: StringObjectDictionary<OrganizationModelType> = useSelector((state: RdxStore) => state.org.organizations);
    const organizationUsers: StringObjectDictionary<OrganizationUsersModelType> = useSelector((state: RdxStore) => state.org.organizationUsers);

    const [search, setSearch] = useState<string>("");
    const users = useUsers();
    const api = useOrganizationsApi();

    const [editModel, setEditModel] = useState<OrganizationModelType>({} as OrganizationModelType);

    const load = async () => {
        const s: OrganizationModelType[] = await api.load();
        let change = {};
        s.forEach(o => change[o?.id] = o);
        dispatch({ type: CHANGE_ORG_ORGANIZATION, payload: change });
    }

    const onUpdate = async (e: OrganizationModelType): Promise<boolean> => {
        var ret = await api.onUpdate(e);
        await load();
        return ret;
    }
    const onAddOrganization = async (e: OrganizationModelType): Promise<boolean> => {
        var ret = await api.onAddOrganization(e);
        await load();
        return ret;
    }

    useEffect(() => {
        if (Object.keys(organizations ?? {})?.length > 0) {
            users.ensureUserInfo(Object.keys(organizations ?? {}).map(key => organizations?.[key]?.organizationowneruserid));
        }
    }, [organizations]);

    // Editmodel
    const [isModelValid, setIsModelValid] = useState<boolean>(false);
    useEffect(() => {
        const v = editModel?.name?.length > 2
        //editModel?.organizationnumber?.length > 5 &&
        //editModel?.address?.length > 5 &&
        // editModel?.postaladdress?.length > 5 &&
        // editModel?.contact?.length > 3 &&
        //editModel?.billingemail?.length > 5 &&
        // editModel?.organizationowneruserid?.length > 5;
        setIsModelValid(v);
    }, [, editModel]);

    const [filter, setFilter] = useState<{
        onlyBilling?: boolean,
        removeTest: boolean
    }>({ removeTest: true });


    return {
        // users
        getUser: users.getUser,
        filter: filter,
        setFilter: setFilter,

        // org users
        loadOrgUsers: async (e: string) => {
            const s = await api.getUsers(e);
            let change = {};
            s?.items.forEach(u => change[u?.id] = u);
            dispatch({ type: CHANGE_ORG_ORGANIZATION_USERS, payload: change });
        },
        organizationUsers: organizationUsers,
        getAccountType: (organizationId: string): OrganizationAccounType => {
            const now = (new Date().valueOf()) / 1000;
            if (organizations?.[organizationId]?.premiumexpires > now) { return "premium"; }
            if (organizations?.[organizationId]?.trialexpires > now) { return "trial"; }
            return "basic";
        },
        // Orgs
        organizations: organizations,
        deleteOrganization: async (orgId: string) => {
            const s: boolean = await api.deleteOrganization(orgId);
            return s;
        },
        data: Object.keys(organizations ?? {}).map(key => organizations?.[key]),
        filterdData: Object.keys(organizations ?? {}).map(key => organizations?.[key]).filter(m =>
            (filter.onlyBilling !== true || m.billing === true) &&
            (filter.removeTest === false || m.istestorganization === false) &&
            (!search || m.name?.toLowerCase()?.includes(search))
        ),

        search: search, setSearch: setSearch,
        doSearch: (e: string) => {
            console.log("search: ", e);
            setSearch(e || "");
            load();
        },
        onUpdate: onUpdate,
        onUpdateProps: async (organizationId: string, e: StringObjectDictionary<any>): Promise<boolean> => {
            const s = await api.onUpdateProps(organizationId, e);
            await load();
            return s;
        },
        onAdd: onAddOrganization,
        model: editModel, setModel: setEditModel,
        isModelValid: isModelValid,
    }
}


export const useOrganizationsApi = () => {

    return {
        load: async (): Promise<OrganizationModelType[]> => {
            return await FetchHandler.getJson("/api/organizations");
        },

        onUpdate: async (e: OrganizationModelType): Promise<boolean> => {
            return await FetchHandler.patchJson("/api/organizations/" + e.id, e);
        },
        onUpdateProps: async (organizationId: string, e: StringObjectDictionary<any>): Promise<boolean> => {
            return await FetchHandler.patchJson("/api/organizations/" + organizationId + "/props", e);
        },
        onAddOrganization: async (e: OrganizationModelType): Promise<boolean> => {
            return await FetchHandler.postJson("/api/organizations", e);
        },
        deleteOrganization: async (orgId: string) => {
            const url = "/api/organizations/" + orgId;
            const ret: boolean = await FetchHandler.delete(url);
            return ret;
        },
        getUsers: async (organizationId: string): Promise<RestListContainer<OrganizationUsersModelType>> => {
            const d: RestListContainer<OrganizationUsersModelType> = await FetchHandler.getJson("/api/organizations/" + organizationId + "/users");
            return d;
        }
    }

}

